import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import * as Constants from '../../../../../helpers/constants'
import { ApiHelper } from './../../../../../helpers/apihelper'
import showToastNotification from '../../../../widgets/toastify'
import ConfirmationModal from '../../../../../helpers/confirmationModal'

const DetachBFSProduct = ({ client, userData, getUserInfo }) => {
  const id = useSelector((state) => state.user.id)
  const userName = useSelector((state) => state.user.name)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const handleDetachClick = () => {
    setShowConfirmModal(true)
  }

  const handleConfirmDetach = () => {
    setShowConfirmModal(false)
    const requestBody = {
      co_user_id: userData.user_id,
      cop_user_id: userData.user_id,
      crm_user_data: JSON.stringify({ user_id: id, name: userName }),
      client_secret: Constants.CLIENT_SECRET,
    }

    const body = _.pick(requestBody, ApiHelper(client, 'DETACH_BFS_PRODUCT').API_BODY)

    ApiHelper(client, 'DETACH_BFS_PRODUCT').API(client, body)
      .then((response) => {
        if (response?.status === Constants.CO_API.SUCCESS) {
          const message = response?.data?.message || 'BFS plan detached successfully!'
          showToastNotification({ message, isSuccess: true })
          getUserInfo()
        } else {
          const message = response?.message || 'Something went wrong !!!'
          showToastNotification({ message, isSuccess: false })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <>
      <Button
        className='detach-product-btn'
        variant="outline-primary"
        onClick={handleDetachClick}
      >
        Detach BFS Plan
      </Button>
      <ConfirmationModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmDetach}
        title='Detach BFS Plan'
        message='Are you sure you want to detach this BFS plan from the user?'
        confirmText='Yes, Detach'
        cancelText='Cancel'
      />
    </>
  )
}

export default DetachBFSProduct
